import { Validator } from "helpers/validator";
import { REGEX_NUMERIC_AND_LENGTH } from "../constants";
import { IIdentifierFields, IUPCData, IUPCDataError, UPCRuleType } from "../types";
import { formatMessage } from "lib/globalize-util";
import { SIZE_COLUMN_FIELD, UPC_COLUMN_FIELD } from "helpers/utils/constants";

export class UPCNumericRule extends Validator<IUPCData[], IUPCDataError> {
    private readonly identifierFields: IIdentifierFields[];
    private readonly sizeField = SIZE_COLUMN_FIELD.key;
    private readonly upcField = UPC_COLUMN_FIELD.key;

    constructor(identifierFields: IIdentifierFields[]) {
        super();

        this.identifierFields = identifierFields;
    }

    validate(model: IUPCData[], errors: IUPCDataError): IUPCDataError {
        const numericErrorType = UPCRuleType.UPCNumericRule;
        const hasRequiredColumnsError = !!errors[UPCRuleType.RequiredColumnsRule];

        if (hasRequiredColumnsError) {
            return errors;
        }

        const validationErrors = model.reduce((errors, row) => {
            const size = row[this.sizeField]?.value.toString();
            const rowIdentifiers = this.identifierFields.reduce((acc, identifier) => {
                const rowValue = row[identifier.key]?.value;
                if (rowValue) {
                    acc[identifier.key] = rowValue;
                }
                return acc;
            }, {});

            const upcValue = row[this.upcField]?.value?.toString();

            if (upcValue.length && !REGEX_NUMERIC_AND_LENGTH.test(upcValue)) {
                const productIdentifierFields = Object.values(rowIdentifiers).join("-");
                const productSize = size.toUpperCase();
                const errorMessage = formatMessage("|product| The UPC must be a 12-13 digit number.", {
                    product: `${productIdentifierFields}-${productSize}:`,
                });

                if (errors[numericErrorType]) {
                    errors[numericErrorType].push(errorMessage);
                } else {
                    errors[numericErrorType] = [errorMessage];
                }
            }

            return errors;
        }, errors);

        return super.validate(model, validationErrors);
    }
}
